import React from "react";
import { ColorRing } from "react-loader-spinner";

const Loader = () => {
  return (
    <>
      <ColorRing
        visible={true}
        height="36"
        width="36"
        ariaLabel="color-ring-loading"
        wrapperStyle={{}}
        wrapperClass="color-ring-wrapper"
        colors={["#fff", "#fff", "#fff", "#fff", "#fff"]}
      />
    </>
  );
};

export default Loader;

